import React, { useEffect, useState } from 'react'
import { Box, Button, Checkbox, Flex, Group, Image, MultiSelect, Paper, Select, SimpleGrid, Text, TextInput, NumberInput, Card } from '@mantine/core'
import { useDebouncedCallback } from '@mantine/hooks'
import { getListUserMemberships } from '../../../services/users'
import { getAllCountryList } from '../../../services/location'
import { IconPhotoPlus } from '@tabler/icons-react'
import { Dropzone } from '@mantine/dropzone'
import { validation } from '../../../plugins/validation'
import { notificationError, notificationSuccess } from '../../ui/Notifications'
import LoadingData from '../../ui/LoadingData'
import InputProductActionBanner from './InputProductActionBanner'
import InputSupplierActionBanner from './InputSupplierActionBanner'
import InputBrandActionBanner from './InputBrandActionBanner'
import InputCategoryActionBrand from './InputCategoryActionBanner'
import { addBanner, updateBanner } from '../../../services/banner'

const defaultVal = {
  id: null,
  actionType: 'product',
  name: '',
  position: 'top',
  priority: null,
  status: 'active',
  image: null,
  actionId: [],
  countryBanners: [],
  customUrl: '',
  description: '',
  forOneProduct: false,
  notifySpesificRole: false,
  membershipId: [],
  membershipName: [],
  userOrigin: [],
}

const formValidation = {
  name: {
    isError: false,
    message: ''
  },
  status: {
    isError: false,
    message: ''
  },
  priority: {
    isError: false,
    message: ''
  },
  position: {
    isError: false,
    message: ''
  },
  actionType: {
    isError: false,
    message: ''
  },
  image: {
    isError: false,
    message: 'Image is Required'
  },
  action: {
    isError: false,
    message: '',
  }
}

// list
const statusList = [
  {
    label: 'Active',
    value: 'active',
  },
  {
    label: 'Inactive',
    value: 'inactive',
  },
]

const actionList = [
  {
    label: 'Open Product Page',
    value: 'product',
  },
  {
    label: 'Open Category Page',
    value: 'category',
  },
  {
    label: 'Open Custom Page',
    value: 'custom',
  },
  {
    label: 'Open Supplier Page',
    value: 'supplier',
  },
  {
    label: 'Open Brand Page',
    value: 'brand',
  },
  {
    label: 'Open Category Brand Page',
    value: 'category_brand',
  },
]
const positionList = [
  {
    label: 'Home',
    value: 'home',
  },
  {
    label: 'Top',
    value: 'top',
  },
  {
    label: 'Middle',
    value: 'middle',
  },
  {
    label: 'Bottom',
    value: 'bottom',
  },
  {
    label: 'Middle Full',
    value: 'middle full',
  },
  {
    label: 'Modal 1',
    value: 'modal 1',
  },
  {
    label: 'Modal 2',
    value: 'modal 2',
  },
  {
    label: 'Modal 3',
    value: 'modal 3',
  },
  {
    label: 'Modal 4',
    value: 'modal 4',
  },
  {
    label: 'Modal 5',
    value: 'modal 5',
  },
]

const FormBanner = ({ dataBanner, onCloseModal, reloadList }) => {
  const [formData, setFormData] = useState(defaultVal)
  const [validationForm, setValidationForm] = useState(formValidation)
  const [countryList, setCountryList] = useState([])
  const [userRoleList, setUserRoleList] = useState([])

  const [loadingForm, setLoadingForm] = useState(false)
  const [loadingCountry, setLoadingCountry] = useState(true)

  const [imageUpload, setImageUpload] = useState(null)
  const [imageFile, setImageFile] = useState(null)
  const [recentImage, setRecentImage] = useState(null)

  const handleGetListCountry = useDebouncedCallback(async () => {
    setLoadingCountry(true)
    const parameter = {
      'page[num]': 1,
      'page[limit]': 9999,
      'fields[country]': 'name',
    }
    try {
      const response = await getAllCountryList(parameter)
      const dataCountry = response.data
      const remapDataCountry = dataCountry.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setCountryList(remapDataCountry)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingCountry(false)
    }
  }, 300)

  const handleGetListUserRole = useDebouncedCallback(async () => {
    const parameter = {
      'page[num]': 1,
      'page[limit]': 100,
      'fields[supplier]': 'name',
    }
    try {
      const response = await getListUserMemberships(parameter)
      const dataUserRoles = response.data.data
      const remapDataUserRoles = dataUserRoles.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setUserRoleList(remapDataUserRoles)
    } catch (error) {
      console.log(error)
    }
  }, 300)


  const handleUploadImage = (file) => {
    setValidationForm(formValidation)
    const fileEncoded = file[0]
    const fileReader = new FileReader()
    fileReader.readAsDataURL(fileEncoded)
    fileReader.onload = (reader) => {
      setImageUpload(reader.target.result)
      setImageFile(fileEncoded)
    }
  }

  const handleErrorFile = (file) => {
    setValidationForm(formValidation)
    const fileState = Object.values(file)
    const errorMessage = fileState[0].errors[0].message
    if (errorMessage) {
      const error = {

        image: {
          isError: true,
          message: errorMessage === 'File is larger than 500000 bytes'
            ? 'The maximum allowed banner size is 500kb'
            : errorMessage
        }
      }
      setValidationForm((oldVal) => ({ ...oldVal, ...error }))
    }
  }

  const handleSelectedImage = () => {
    return imageUpload || recentImage || null
  }

  const handleRemoveImage = () => {
    setImageUpload(null)
    setImageFile(null)
    setRecentImage(null)
  }

  useEffect(() => {
    handleGetListCountry()
    handleGetListUserRole()
    if (dataBanner) {
      handleSetForm(dataBanner)
    }
    // eslint-disable-next-line
  }, [dataBanner])

  const handleSetForm = async (banner) => {
    if (banner.image) {
      setRecentImage(banner.image)
    }
    const toArr = (val) => Array.isArray(val) ? val : val ? [val] : []
    const dataDetail = {
      id: banner.id,
      actionType: banner.actionType,
      name: banner.name,
      position: banner.position,
      priority: banner.priority,
      status: banner.status,
      image: banner.image,
      actionId: toArr(banner.actionId),
      countryBanners: toArr(banner.countryBanners),
      customUrl: banner.customUrl,
      description: banner.description,
      forOneProduct: banner.forOneProduct,
      membershipId: toArr(banner.membershipId),
      notifySpesificRole: Boolean(banner.membershipId && toArr(banner.membershipId).length !== 0),
      membershipName: toArr(banner.membershipName),
      userOrigin: toArr(banner.userOrigin),
    }

    setFormData(dataDetail)
  }

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val }))
  }

  // action logic
  const handleChangeActionType = (val) => {
    handleChangeForm('customUrl', '')
    handleChangeForm('actionId', [])
    setValidationForm((oldVal) => ({ ...oldVal, action: { isError: false, message: '' } }))
    handleChangeForm('actionType', val)
  }

  // submit logic
  const generatePayload = (form) => {
    const payload = {
      name: `${form.name}`,
      action_type: form.actionType,
      status: form.status,
      priority: form.priority || null,
      position: form.position,
    }

    if (imageUpload)
      payload.image_encoded = imageUpload

    if (form.countryBanners.length !== 0)
      payload.country_banners = form.countryBanners.join(',')

    if (form.notifySpesificRole && form.membershipId.length !== 0)
      payload.membership_id = form.membershipId

    if (form.userOrigin.length !== 0)
      payload.user_origin = form.userOrigin

    if (form.actionId.length !== 0 && form.actionType !== 'custom') {
      if (form.actionType === 'product')
        payload.action_id = form.actionId
      else
        payload.action_id = [form.actionId[form.actionId.length - 1]]
    }
    else {
      payload.action_id = ['0']
    }

    if (form.customUrl)
      payload.custom_url = form.customUrl

    if (form.id)
      payload._method = 'PUT'

    return payload
  }

  const checkValidation = (form) => {
    let validateForm = {}

    const handleActionValidation = (form) => {
      if (form.actionType === 'custom') {
        return form.customUrl
      }
      else {
        return form.actionId?.join('') || null
      }
    }

    // --- validation ---
    validateForm = {
      name: form.name,
      priority: form.priority,
      image: handleSelectedImage(),
      action: handleActionValidation(form)
    }
    return validation(validateForm, setValidationForm)
  }

  // submit data
  const submitBanner = async (form) => {
    setLoadingForm(true)
    setValidationForm(formValidation)
    let methodFunction = null
    let titleMessageSuccess = ''
    let captionMessageSuccess = ''
    let titleMessageError = ''
    let captionMessageError = ''

    const isError = checkValidation(form)

    if (isError) {
      setLoadingForm(false)
      return
    }

    // generate payload with base64 image
    const payload = generatePayload(form)

    if (dataBanner === null) {
      methodFunction = addBanner(payload)
      titleMessageSuccess = 'Add Banner Successfully'
      captionMessageSuccess = 'You have been added new Banner'
      titleMessageError = 'Add Banner Error'
    } else {
      methodFunction = updateBanner(form.id, payload)
      titleMessageSuccess = 'Update Banner Successfully'
      captionMessageSuccess = 'You have been updated data Banner'
      titleMessageError = 'Update Banner Error'
    }

    // helper
    const _onSuccess = () => {
      onCloseModal()
      reloadList()
      notificationSuccess(titleMessageSuccess, captionMessageSuccess)
    }

    try {
      const response = await methodFunction
      if (response.success) {
        _onSuccess()
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message
      if (errorMessage && typeof errorMessage === 'object') {
        captionMessageError = Object.values(errorMessage).flat().join(', ')
      } else if (errorMessage) {
        captionMessageError = errorMessage
      } else {
        captionMessageError = 'Please recheck your form'
      }
      notificationError(titleMessageError, captionMessageError)
    } finally {
      setLoadingForm(false)
    }
  }

  const renderNotifyUserRole = () => {
    if (formData.notifySpesificRole) {
      return (
        <Box my="md">
          <MultiSelect
            name='notify_user_role_list'
            value={formData.membershipId}
            label='Notify to spesific user role'
            size='xs'
            searchable
            data={userRoleList}
            onChange={(val) => handleChangeForm('membershipId', val)}
            clearable
          />
        </Box>
      )
    }
  }

  const renderImageForm = () => {
    if (!handleSelectedImage()) {
      return (
        <Box my={10}>
          <Dropzone
            accept={[
              'image/png',
              'image/jpeg',
              'image/gif',
            ]}
            onDrop={(files) => handleUploadImage(files)}
            onReject={(files) => handleErrorFile(files)}
            maxSize={500000}
          >
            <Box ta='center' my={30}>
              <Flex justify='center' mb={10}>
                <IconPhotoPlus size={50} color='gray' />
              </Flex>
              <Box>
                <Text fz={12} c='blue.9'>Upload Image Here</Text>
                <Text fz={12} c='gray.6'>PNG, JPG, GIF up to 500kb</Text>
              </Box>
            </Box>
          </Dropzone>

          {validationForm.image.isError && <Text fz={10} c={'red'} mt="xs"> {validationForm.image.message} </Text>}
        </Box>
      )
    }

    return (
      <Box>
        <Text fz={12} fw='600' c={'red'} style={{ textAlign: 'end', cursor: 'pointer' }} onClick={() => handleRemoveImage()}>Remove Image</Text>
        <Paper shadow="sm" withBorder radius='md' style={{ backgroundColor: '#f1f2f5' }}>
          <Flex justify='center'>
            <Image src={handleSelectedImage()} w='auto' radius='md' h={250} fit='contain' />
          </Flex>
        </Paper>
      </Box>
    )
  }

  const renderSwitchActionInput = () => {
    if (formData.actionType === 'product') {
      return (
        <InputProductActionBanner
          dataProductIds={formData.actionId}
          onChange={(val) => handleChangeForm('actionId', val)}
          isError={validationForm.action.isError}
        />
      )
    }

    if (formData.actionType === 'supplier') {
      return (
        <InputSupplierActionBanner
          dataSupplierIds={formData.actionId}
          onChange={(val) => handleChangeForm('actionId', val ? [val] : [])}
          isError={validationForm.action.isError}
        />
      )
    }

    if (formData.actionType === 'brand') {
      return (
        <InputBrandActionBanner
          dataBrandIds={formData.actionId}
          onChange={(val) => handleChangeForm('actionId', val ? [val] : [])}
          isError={validationForm.action.isError}
        />
      )
    }

    if (formData.actionType === 'category' || formData.actionType === 'category_brand') {
      return (
        <InputCategoryActionBrand
          key={formData.actionType} // for re render triggering
          dataIds={formData.actionId}
          onChange={(val) => handleChangeForm('actionId', val ? [val] : [])}
          isError={validationForm.action.isError}
        />
      )
    }

    if (formData.actionType === 'custom') {
      return (
        <Box my="sm">
          <TextInput
            name='custom_url'
            value={formData.customUrl}
            label='Custom Url'
            error={validationForm.action.isError ? `${validationForm.action.message}` : ''}
            onChange={(val) => handleChangeForm('customUrl', val.target.value)}
            withAsterisk
            size='xs'
          />
        </Box>
      )
    }
  }

  const mappingFormBanner = () => {
    return (
      <Box>
        <Box my="sm">
          {renderImageForm()}
        </Box>

        <Box my="sm">
          <TextInput
            name='name'
            value={formData.name}
            label='Name Banner'
            error={validationForm.name.isError ? `${validationForm.name.message}` : ''}
            onChange={(val) => handleChangeForm('name', val.target.value)}
            withAsterisk
            size='xs'
          />
        </Box>

        <SimpleGrid cols={2} verticalSpacing="sm" mb='sm'>
          <Select
            name='active'
            value={formData.status}
            label='Status'
            data={statusList}
            onChange={(val) => handleChangeForm('status', val)}
            error={validationForm.status.isError ? `${validationForm.status.message}` : ''}
            size='xs'
            allowDeselect={false}
            withAsterisk
          />

          <Box>
            <NumberInput
              name='priority'
              value={formData.priority}
              label='Priority'
              error={validationForm.priority.isError ? `${validationForm.priority.message}` : ''}
              onChange={(val) => handleChangeForm('priority', val)}
              withAsterisk
              size='xs'
            />
          </Box>

          <Select
            name='position'
            value={formData.position}
            label='Position'
            data={positionList}
            onChange={(val) => handleChangeForm('position', val)}
            error={validationForm.position.isError ? `${validationForm.position.message}` : ''}
            size='xs'
            allowDeselect={false}
            withAsterisk
          />

          <Select
            name='action'
            value={formData.actionType}
            label='Action Banner'
            data={actionList}
            onChange={(val) => handleChangeActionType(val)}
            error={validationForm.actionType.isError ? `${validationForm.actionType.message}` : ''}
            size='xs'
            allowDeselect={false}
            withAsterisk
          />
        </SimpleGrid>

        <Box my="sm">
          {renderSwitchActionInput()}
        </Box>

        <Box my="sm">
          <MultiSelect
            name='country_origin_product'
            value={formData.countryBanners}
            label='Country Origin Product'
            size='xs'
            onChange={(val) => handleChangeForm('countryBanners', val)}
            searchable
            data={countryList}
            clearable
          />
        </Box>

        <Box my="sm">
          <MultiSelect
            name='country_signup_user'
            value={formData.userOrigin}
            label='Country Signup User'
            size='xs'
            onChange={(val) => handleChangeForm('userOrigin', val)}
            searchable
            data={countryList}
            clearable
          />
        </Box>

        <Card my="md" padding="sm" radius="md" withBorder>
          <Checkbox
            checked={formData.notifySpesificRole}
            size='xs'
            label="Notify to spesific user role"
            onChange={(val) => handleChangeForm('notifySpesificRole', val.target.checked)}
          />

          {renderNotifyUserRole()}
        </Card>

        <Box mt={20}>
          <Flex justify='flex-end'>
            <Group>
              <Button size='xs' variant="outline" onClick={onCloseModal}>Close</Button>
              <Button size='xs' loading={loadingForm} variant="filled" onClick={() => submitBanner(formData)}>{dataBanner !== null ? 'Update' : 'Create'}</Button>
            </Group>
          </Flex>
        </Box>
      </Box>
    )
  }

  return (
    <Box>
      {loadingCountry ? <LoadingData /> : mappingFormBanner()}
    </Box>
  )
}

export default FormBanner
